import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

export const logo = css`
  max-width: ${spacing(18)};
`

export const header = css`
  display: flex;
  align-items: center;
`

export const flag = css`
  width: ${spacing(4)};
`

export const resultsWrapper = css`
  ${MQ.NOT_PHONES} {
    text-align: right;
  }
`

export const row = css`
  ${MQ.PHONES} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

// TODO: Temp styles
export const results = css`
  display: inline-block;

  border: 1px solid ${colors.black100};
  border-radius: ${spacing(1)};

  overflow: hidden;

  min-width: ${spacing(20)};

  header {
    background-color: ${colors.black100};
    color: ${colors.white100};

    padding: ${spacing(1)};

    text-align: center;
  }

  main {
    display: flex;

    align-items: center;

    & > div {
      flex: 1;

      padding: ${spacing(1)};

      text-align: center;
    }
  }

  footer {
    border-top: 1px solid ${colors.black100};

    padding: ${spacing(1)};

    text-align: center;
  }
`
